<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{site ? site.name : ''}}动环配置</h1>

    <el-radio-group v-if="isHiveCategory" v-model="type" size="small" style="margin-left: 10px;" @change="radioChange">
      <el-radio-button label="1">区域</el-radio-button>
      <el-radio-button label="2">分组</el-radio-button>
    </el-radio-group>
  </template>

  <template #toolbar>
    <el-button
      type="primary"
      size="small"
      @click="onOpenEditor"
    >因子分组</el-button>
  </template>

  <template #body>
    <e-chart ref="env-config-chart" @initialized="onChartInitialized" />
    <div v-show="tree.length === 0" class="no-env-config">
      <h2>当前站点没有动环配置</h2>
    </div>
  </template>

  <template #editor>
    <env-config-editor
      ref="editor"
      :env-factor="envFactor"
      @save="getEnvFactorCategory"
    />
  </template>
</layout-content>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseListEditor from '../../BaseListEditor'
import EChart from '../../../components/Charts/ECharts'
import EnvConfigEditor from './EnvConfigEditor'

export default {
  name: 'EnvConfig',
  components: {EChart, EnvConfigEditor},
  extends: BaseListEditor,
  props: {
    site: {
      required: true
    }
  },
  data () {
    return {
      type: '1',
      envCategoryList: [],
      isShowRadio: false
    }
  },
  computed: {
    ...mapGetters({
      envFactorMap: 'EnvFactor/map',
      areaSiteIdMap: 'EnvFactor/areaMap'
    }),
    isHiveCategory () {
      let {site} = this

      if (!site) {
        return false
      }
      let data = this.envFactorMap[site.id]
      let filterData = Object.values(data).filter(el => el.categoryId)

      return filterData.length > 0
    },
    envFactor () {
      let {site} = this

      if (!site) {
        return []
      }

      let data = Object.values(this.envFactorMap[site.id])

      return data.filter(el => !el.isDelete)
    },
    areaMap () {
      let {site} = this

      if (!site) {
        return null
      }

      let areaMap = this.areaSiteIdMap[site.id]
      return areaMap ? JSON.parse(JSON.stringify(areaMap)) : null
    },
    tree () {
      let {areaMap} = this

      if (!areaMap) {
        return []
      }

      let {site} = this
      let envFactorMap = this.envFactorMap[site.id] || {}
      if (this.type === '1') {
        let areas = Object.values(areaMap).map(area => {
          let {isDelete} = area

          return {
            id: area.id,
            name: `${area.name}${isDelete ? '(已拆除)' : ''}`,
            parentId: area.parentId,
            isDelete
          }
        })

        let tmp = Object.values(areaMap).reduce((list, {id, factorIds}) => factorIds.filter(factorId => envFactorMap[factorId]).sort((a, b) => envFactorMap[a].name.localeCompare(envFactorMap[b].name)).reduce((list, factorId) => {
          list.push({
            ...envFactorMap[factorId],
            parentId: id,
            label: {
              color: '#007ad0'
            }
          })

          return list
        }, list), [])

        areaMap = areas.reduce((map, area) => {
          map[area.id] = area
          return map
        }, {})

        tmp.push(...areas)

        let roots = []

        for (let i = 0; i < tmp.length; i++) {
          let child = tmp[i]
          let {parentId} = child
          let parent = areaMap[parentId]

          if (parent) {
            let {children} = parent

            if (!children) {
              children = parent.children = []
              // tmp.push(parent)
            }

            children.push(child)
          } else {
            roots.push({
              ...child,
              label: {
                fontSize: 12
              }
            })
          }
        }

        return roots.length === 1 ? roots : [{
          id: site.id,
          name: site.name,
          label: {
            fontSize: 12
          },
          children: roots
        }]
      }

      if (!Object.values(envFactorMap).length) {
        return []
      }

      let data = Object.values(envFactorMap).filter(el => !el.isDelete)

      let group = this.envCategoryList.reduce((map, el) => {
        map[el.id] = {
          id: el.id,
          name: el.name,
          label: {
            fontSize: 12
          },
          children: []
        }

        return map
      }, {})

      let newGroupMap = Object.assign(JSON.parse(JSON.stringify(group)), {
        noneGroup: {
          id: 'noneGroup',
          name: '未知分组',
          label: {
            fontSize: 12
          },
          children: []
        }
      })

      data.sort((x, y) => x.name.localeCompare(y.name)).forEach(factor => {
        if (newGroupMap[factor.categoryId]) {
          newGroupMap[factor.categoryId].children.push({
            ...factor,
            label: {
              color: '#007ad0'
            }
          })
        } else {
          newGroupMap.noneGroup.children.push({
            ...factor,
            label: {
              color: '#007ad0'
            }
          })
        }
      })

      return [{
        id: site.id,
        name: site.name,
        label: {
          fontSize: 12
        },
        children: Object.values(newGroupMap).map(el => {
          if (el.children.length > 0) {
            return el
          }
        }).filter(Boolean)
      }]
    }
  },
  methods: {
    getEnvFactorCategory () {
      this.$api.EnvFactor.getEnvFactorCategory().then(data => {
        this.envCategoryList = data
      }).catch(console.error)
    },
    radioChange () {
      this.render()
    },
    render () {
      let {tree} = this
      let chart = this.$refs['env-config-chart']

      if (tree.length === 0) {
        chart.clear()
        return
      }

      chart.setOpt({
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        animation: false,
        series: [{
          type: 'tree',
          data: tree,
          top: '1%',
          left: '7%',
          bottom: '1%',
          right: '20%',
          symbolSize: 0,
          label: {
            position: 'left',
            verticalAlign: 'middle',
            align: 'right',
            fontSize: 10
          },
          leaves: {
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left'
            }
          },
          expandAndCollapse: false,
          animationDuration: 550,
          animationDurationUpdate: 750
        }]
      })
    },
    onChartInitialized () {
      this.initialized = true
      this.render()
    }
  },
  watch: {
    tree () {
      if (this.initialized) {
        this.render()
      }
    }
  },
  created () {
    this.getEnvFactorCategory()
  }
}
</script>

<style lang="scss" scoped>
.area-tree-chart-wrapper {
  display: grid;
  grid-template-rows: max-content auto;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  .no-env-config {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/EnvConfig.vue